import { AutomaticInviteType } from '@pflegia/types/common/enums/automatic-invite-type.enum';

export {
  /** @deprecated Import from @pflegia/types/common instead. */
  AutomaticInviteType,
};
